import {
  Camera,
  CheckCircle,
  CheckCircleIcon,
  FileText,
  Search,
  Shield,
  User,
} from "lucide-react";
import "./pre-rental-verification.css";
import OrbitingSkills from "./../orbiting-skills";
import StartVerifyingRentersButton from "./../start-verifying-renters-button";

export function PreRentalVerification() {
  return (
    <section className="r2-prv">
      <div className="r2-prv__grid">
        <div className="r2-prv__content">
          <h2 className="r2-prv__title">Pre-rental verification tools</h2>

          <p className="r2-prv__lead">
            Trust and safety, built in. Our AI verification engine screens every
            renter—so only qualified renters are approved and your fleet stays
            protected.
          </p>

          <div className="r2-prv__feature-list">
            <div className="r2-prv__feature">
              <CheckCircleIcon className="r2-prv__feature-icon" />
              <span className="r2-prv__feature-text">
                Save time with instant renter decisions
              </span>
            </div>
            <div className="r2-prv__feature">
              <CheckCircleIcon className="r2-prv__feature-icon" />
              <span className="r2-prv__feature-text">
                Lower risk by flagging high-risk renters
              </span>
            </div>
            <div className="r2-prv__feature">
              <CheckCircleIcon className="r2-prv__feature-icon" />
              <span className="r2-prv__feature-text">
                Protect revenue with consistent pre-rental checks
              </span>
            </div>
          </div>

          <div className="r2-prv__pill-grid">
            <span className="r2-prv__pill r2-prv__pill--identity">
              <User className="r2-prv__pill-icon" />
              Identity Verification
            </span>
            <span className="r2-prv__pill r2-prv__pill--criminal">
              <Search className="r2-prv__pill-icon" />
              Criminal Record
            </span>
            <span className="r2-prv__pill r2-prv__pill--mvr">
              <FileText className="r2-prv__pill-icon" />
              Access MVR Data
            </span>
            <span className="r2-prv__pill r2-prv__pill--insurance">
              <Shield className="r2-prv__pill-icon" />
              Insurance Validation
            </span>
            <span className="r2-prv__pill r2-prv__pill--license">
              <CheckCircle className="r2-prv__pill-icon" />
              License Verification
            </span>
            <span className="r2-prv__pill r2-prv__pill--selfie">
              <Camera className="r2-prv__pill-icon" />
              Selfie Biometrics
            </span>
          </div>

          <div className="r2-prv__cta">
            <div className="r2-prv__cta-row">
              <StartVerifyingRentersButton size={"small"} />
            </div>
          </div>
        </div>

        {/* Animation - right column on desktop, hidden on mobile */}
        <div className="r2-prv__animation">
          <div className="r2-prv__animation-frame">
            <OrbitingSkills />
          </div>
        </div>
      </div>
    </section>
  );
}
